import { verifyAccountPhone as verifyAccountPhoneRequest } from "@vetty/api-sdk";
import { axiosInstance } from "./axiosInstance.helper";

export async function verifyAccountPhone(
  phone: string,
  code: string
): Promise<boolean> {
  try {
    await verifyAccountPhoneRequest(axiosInstance, {
      phone,
      code,
    });
    return true;
  } catch {
    return false;
  }
}
